const category = 'AppSpecificCorrespondence';

const cards = [
    {
        name: "Communication",
        id: "Communication",
        category: "Communication",
        fields: [
            [{ id: "ShouldSendOutboundCommunication" }],
            [{ id: "SuppressOutboundCommunicationWarning" }],
            [{ id: "EmailAddressForCustomerSuppressedCorrespondence" }],
            [{ id: "ShouldEmailIncludeBCC" }],
            [{ id: "EmailAddressForBCC" }],
        ],
    },
    {
        name: "Print",
        id: "print",
        category: "Communication",
        fields: [
            [{ id: "ShouldPrintMailInColor" }],
            [{ id: "ShouldPrintMailDoubleSided" }],
        ],
    },
    {
        name: "Correspondence",
        id: "correspondence",
        fields: [
            [{ id: "UseLatestSORAddress" }],
            [{ id: "AutoReplyOnReceivingDocumentation" }],
            [
                {
                    id: "UseDenyJustificationInCorrespondence",
                },
            ],
            [
                {
                    id: "AllowFreeFormDenyJustification",
                },
            ],
            [{ id: "RequiredNumberOfDenyJustifications" }],
            [
                {
                    id: "DenyJustificationIntroductoryParagraph",
                },
            ],
            [
                {
                    id: "DenyJustificationIntroductoryParagraphEs",
                },
            ],
            [
                {
                    id: "DenyJustificationGuidance",
                },
            ],
            [
                {
                    id: "DenyJustificationList",
                    listItems: [
                        "ApplicableTo",
                        "RulePurpose",
                        "JustificationText",
                        "RulePurposeEs",
                        "JustificationTextEs",
                    ],
                },
            ],
            [
                {

                }
            ], [
                {
                    id: "CorrespondenceAllowSplitLetterContent",
                    groupType: "checklist",
                    layout: [
                        [{ id: "SplitLetterByContentDescription" }],
                        [{ id: "SplitLetterByContentLabel" }],
                        [{ id: "SplitWithdrawnLetterByContent" }]
                    ]
                }
            ],
        ],
    },
    {
        name: "Claim Status Letters",
        id: "claimStatusLetters",
        tooltip: "The Status letter is available to users via the Communication Hub.  Additionally, the following automated option is available (when selected).",
        fields: [[
            {
                id: "ClaimStatusLettersOption",
                layout: [
                    [
                        {
                            type: "contentGroup",
                            items: [
                                {
                                    type: "config",
                                    id: "ReoccuringAutomatedStatusLetterInDaysContentPre",
                                },
                                {
                                    type: "config",
                                    id: "ReoccuringAutomatedStatusLetterInDays",
                                },
                                {
                                    type: "config",
                                    id: "ReoccuringAutomatedStatusLetterInDaysContentPost",
                                },
                            ],
                        }
                    ]
                ]
            },
        ]]
    },
];

export { cards, category };